import React from "react";

// Icons
const ScaleIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-slate-600"
  >
    <path
      d="M12 5.5l4 6.5h-8l4-6.5zM6 12l-2.5 5h5L6 12zm12 0l-2.5 5h5L18 12zm-6 5v4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const yTicks = ["100", "80", "60", "40", "20", "0"];
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const ChartArea = () => (
  <div className="flex">
    <div className="flex flex-col justify-between pr-4 text-xs text-gray-400">
      {yTicks.map((tick) => (
        <span key={tick}>{tick}</span>
      ))}
    </div>
    <div className="flex-1">
      <div className="relative h-[190px]">
        <svg
          className="absolute inset-0 h-full w-full"
          viewBox="0 0 440 190"
          preserveAspectRatio="none"
        >
          <g stroke="#EEF2F7" strokeWidth="1">
            {[0, 1, 2, 3, 4].map((row) => (
              <line
                key={row}
                x1="0"
                y1={20 + row * 34}
                x2="440"
                y2={20 + row * 34}
              />
            ))}
          </g>
          <path
            d="M0,88 L40,74 L80,84 L120,66 L160,78 L200,70 L240,82 L280,74 L320,86 L360,74 L400,80 L440,72 L440,190 L0,190 Z"
            fill="#EAF6FF"
            stroke="#9AB4BF"
            strokeWidth="1.5"
          />
          <path
            d="M0,128 L40,112 L80,116 L120,98 L160,110 L200,104 L240,116 L280,108 L320,120 L360,112 L400,118 L440,108 L440,190 L0,190 Z"
            fill="#EAF7E0"
            stroke="#8FA04F"
            strokeWidth="1.5"
          />
        </svg>
      </div>
      <div className="mt-3 grid grid-cols-12 text-xs text-gray-400">
        {months.map((month) => (
          <span key={month} className="text-center">
            {month}
          </span>
        ))}
      </div>
    </div>
  </div>
);

const FilterHeader = () => (
  <div className="mb-4 grid grid-cols-2 gap-5 text-sm text-gray-600">
    <div>
      <div className="mb-2 text-[15px] font-semibold text-gray-700">Asset Name</div>
      <button
        type="button"
        className="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-xs text-gray-700 shadow-[0_1px_0_0_rgba(148,163,184,0.08),0_0_0_1px_rgba(226,232,240,0.9)]"
      >
        Turbine flow
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="#6B7280"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
    <div>
      <div className="mb-2 text-[15px] font-semibold text-gray-700">Date Issued</div>
      <button
        type="button"
        className="flex w-full items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-700 shadow-[0_1px_0_0_rgba(148,163,184,0.08),0_0_0_1px_rgba(226,232,240,0.9)]"
      >
        <span className="inline-flex h-5 w-5 items-center justify-center text-gray-500">
          <svg
            width="14"
            height="14"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 3.5V6M14 3.5V6M3 8.5H17M4.5 6H15.5C16.328 6 17 6.672 17 7.5V15.5C17 16.328 16.328 17 15.5 17H4.5C3.672 17 3 16.328 3 15.5V7.5C3 6.672 3.672 6 4.5 6Z"
              stroke="#6B7280"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span className="min-w-0 flex-1 truncate whitespace-nowrap text-xs">
          Jan 6, 2022 - Jan 13, 2022
        </span>
      </button>
    </div>
  </div>
);

export const RealTimeDesk = () => {
  return (
    <div className="ml-6 mt-[70px] max-w-[1019px] mb-[1019px] rounded-[14px] border border-gray-200 bg-white p-6 shadow-[0_12px_28px_rgba(15,23,42,0.08)]">
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-3 text-base font-semibold text-slate-800">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-white">
            <ScaleIcon />
          </span>
          Compare Assets
        </div>
        <div className="text-sm font-semibold text-emerald-600">Net: +142 MW</div>
      </div>
      <div className="relative grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10">
        <div className="rounded-md">
          <FilterHeader />
          <ChartArea />
        </div>
        <div className="rounded-md">
          <FilterHeader />
          <ChartArea />
        </div>
        <div className="pointer-events-none hidden lg:block lg:absolute lg:inset-y-4 lg:left-1/2 lg:w-px lg:-translate-x-1/2 lg:bg-gray-200/70" />
      </div>
    </div>
  );
};

export default RealTimeDesk;
